__turbopack_context__.v({
  "mapButton": "homeMapCallout-module-scss-module__dpnR7W__mapButton",
  "mapCallout": "homeMapCallout-module-scss-module__dpnR7W__mapCallout",
  "mapContent": "homeMapCallout-module-scss-module__dpnR7W__mapContent",
  "mapDescription": "homeMapCallout-module-scss-module__dpnR7W__mapDescription",
  "mapMediaFrame": "homeMapCallout-module-scss-module__dpnR7W__mapMediaFrame",
  "mapTitle": "homeMapCallout-module-scss-module__dpnR7W__mapTitle",
});
